import React from 'react';
import chroma from 'chroma-js';
import { NavLink } from '@react-router';
import { styled, TextV2 } from '@withjoy/joykit';
import { IMenuItem } from './WorkspaceMenu';
import { INavTheme } from './Workspace';

const Item = styled.div<{}>`
  width: 100px;
  height: 100px;
  overflow: hidden;
  padding: 8px;
  text-align: center;
  color: #1a1a1a;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 19.6px */
  letter-spacing: -0.035px;
  user-select: none;
`;
const ColoredCircle = styled.button<{ color: string; highlightColor: string; shadedColor: string; shadowColor: string }>`
  width: 48px;
  height: 48px;
  border-radius: 32px;
  margin: auto;
  background: ${props => `linear-gradient(180deg, ${props.color} 0%, ${props.shadedColor} 100%)`};
  box-shadow: 0px 1px 1px ${props => props.shadowColor};
  user-select: none;
  transition: all 0.2s ease-in-out;
  transition-delay: 0ms;
  cursor: pointer;
  &:hover,
  &:focus {
    transform: scale(1.02);
    box-shadow: 0px 1px 2px ${props => props.shadowColor};
  }
`;

const ItemIcon = styled.img`
  width: 48px;
  height: 48px;
`;

interface IMenuItemProps extends IMenuItem {
  onMenuItemClick?: (item: IMenuItem) => void;
  theme: INavTheme;
}

interface IMenuWrapperProps {
  link?: string;
  route?: string;
  children: React.ReactNode;
}

const MenuItemWrapper: React.FC<IMenuWrapperProps> = ({ link, route, children }) => {
  if (route) {
    return <NavLink to={route ?? ''}>{children}</NavLink>;
  }
  if (link) {
    return (
      <a
        href={link}
        style={{ textDecoration: 'none' }}
      >
        {children}
      </a>
    );
  }
  // Fallback to a div if neither route nor link is provided
  return <div>{children}</div>;
};

export const MenuItem: React.FC<IMenuItemProps> = ({ label, color, iconUrl, link, route, keywords, onMenuItemClick, theme, description }) => {
  const shadowColor = chroma(color.end).darken(2).toString();
  const hoverColor = chroma(color.start).brighten(0.5).toString();
  const handleNavigate = () => {
    if (onMenuItemClick) {
      onMenuItemClick({ label, color, iconUrl, link, keywords });
    }
  };

  return (
    <MenuItemWrapper
      link={link}
      route={route || ''}
    >
      <Item title={description ?? ''}>
        <ColoredCircle
          type="button"
          color={color.start}
          highlightColor={hoverColor}
          shadedColor={color.end}
          shadowColor={shadowColor}
          onClick={link ? handleNavigate : undefined}
        >
          {iconUrl && (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <ItemIcon
                src={iconUrl}
                title={''}
                alt=""
                style={{}}
              />
            </div>
          )}
        </ColoredCircle>
        <TextV2
          typographyVariant={'label1'}
          color={theme.font}
          marginTop={'6px'}
        >
          {label}
        </TextV2>
      </Item>
    </MenuItemWrapper>
  );
};
